import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import useOutsideClick from '../../../hooks/useOutsideClick';
import CmdTableSettingsMenu from './CmdTableSettingsMenu';
import { isTableSettingsMenuOpenedAtom } from '../CmdTableState';
import useAnalytics from '../../../hooks/useAnalytics';
import { getTableName } from '../CmdTableService';

interface ICmdTableSettingsProps {
  tableId: string;
  actionColumnEnabled?: boolean;
  sort?: {
    column: string;
    direction: string;
  };
  tableName: string;
  translationKeys: { [key: string]: string };
  locked?: string[];
}

function CmdTableSettings(props: ICmdTableSettingsProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const clickOutsideRef: React.RefObject<any> = React.useRef();
  const [isMenuOpened, setIsMenuOpened] = useRecoilState(isTableSettingsMenuOpenedAtom);
  const { trackEvent } = useAnalytics();

  useOutsideClick(clickOutsideRef, () => {
    setIsMenuOpened(false);
  });

  const handleShowTableSettingsMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsMenuOpened(!isMenuOpened);
    trackEvent([`table settings ${getTableName(props.tableName)}`, 'click', 'Open table settings']);
  };

  return (
    <div
      ref={clickOutsideRef}
      className={`b-dropdown b-dropdown--switcher ${isMenuOpened ? 'open' : ''} `}
      style={{ width: '250px' }}
    >
      <div
        onClick={handleShowTableSettingsMenu}
        className="form-control-labels"
        data-cy="tlclite-open-table-settings"
      >
        <img src="/images/icons/drag-drop-row.svg" alt="settings" />
        <span className="ml-2">{f({ id: 'tables.tripsOverview.tableSettings.header' })}</span>
      </div>
      {isMenuOpened && (
        <CmdTableSettingsMenu
          tableId={props.tableId}
          actionColumnEnabled={props.actionColumnEnabled}
          sort={props.sort}
          tableName="cost_center"
          translationKeys={props.translationKeys}
          locked={props.locked}
        />
      )}
    </div>
  );
}

export default CmdTableSettings;
